import {
	FCM_PSF_SHARE_BUTTON_CONFIG,
	FCM_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	FCM_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE,
} from '@change-corgi/fcm/configs';

import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const REDDIT_SHARE_BUTTON_EXPERIMENT_NAME = 'psf_reddit_share_button_experiment';
export const INSTAGRAM_STORIES_SHARE_BUTTON_EXPERIMENT_NAME = 'psf_instagram_stories_share_button_experiment';

export const FCM_EXPERIMENT_REDDIT_SHARE_BUTTON = createExperimentFcmConfig({
	experimentName: REDDIT_SHARE_BUTTON_EXPERIMENT_NAME,
	fcmConfigs: {
		buttonList: FCM_PSF_SHARE_BUTTON_CONFIG,
	},
	isEnabled: ({ fcm: { buttonList } }) => buttonList.includes('reddit'),
});

export const FCM_EXPERIMENT_SHARE_COPY_HEADLINES_WHATSAPP = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config.experimentName,
	fcmConfigs: {
		config: FCM_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE,
	},
	isEnabled: ({ fcm: { config } }) => {
		return config.isEnabled;
	},
});

export const FCM_EXPERIMENT_INSTAGRAM_STORIES_SHARE_BUTTON = createExperimentFcmConfig({
	experimentName: INSTAGRAM_STORIES_SHARE_BUTTON_EXPERIMENT_NAME,
	fcmConfigs: {
		buttonList: FCM_PSF_SHARE_BUTTON_CONFIG,
	},
	isEnabled: ({ fcm: { buttonList } }) => buttonList.includes('instagramStories'),
});

export const FCM_EXPERIMENT_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config.experimentName,
	fcmConfigs: {
		config: FCM_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	},
	isEnabled: ({ fcm: { config } }) => {
		return config.isEnabled;
	},
});
